import React, { useCallback, useState } from "react";
import { ITabs } from "types";

export default function Tabs({ tabs }: ITabs) {

    const [activeTab, setActiveTab] = useState(0);

    const renderContent = useCallback(() => (<p className="text-gray-600 mt-4">{tabs[activeTab].content}</p>), [activeTab]);

    return (
        <div className="w-full bg-white">
            <div className="flex border-b border-gray-200">
                {tabs.map((tab, index) => (
                    <button
                        key={`tab-${index}`}
                        onClick={() => setActiveTab(index)}
                        className={`px-6 py-3 text-sm font-medium ${activeTab === index
                            ? "text-white bg-blue-500"
                            : "text-gray-500 hover:text-blue-500"
                            } focus:outline-none transition`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="p-4 bg-white">{renderContent()}</div>
        </div>
    );
}
